export const getAreaTag = (area: CASLink.Device.Ui.ViewModel.Dashboard.DashboardAreaSummary): string => {
    return area.areaTag || 'Unassigned';
};

export const getAreaIcon = (area: CASLink.Device.Ui.ViewModel.Dashboard.DashboardAreaSummary): string => {
    return area.areaIcon;
};
